import {
  clampQcFailDispositionToastMessage,
  clampQcMechanicalFailureSkipsOtherTests,
  resolveClampQcFailDispositionPile,
  type ClampQcFailDispositionPile,
} from "@integrator-src/config/clampqc-fail-disposition";
import {
  clampQcDragBandForDrag,
  clampQcDragFromUnloadedLoadedLines,
  clampQcDragLadderFromSettings,
  clampQcInductanceReadingIsOutOfBand,
  clampQcLineHarvestFailsFromDragDraft,
  type ClampQcHubSettingsPayload,
} from "./clampQcSettingsApi";
import {
  type ClampQcInductanceEvaluationOptions,
  type DraftInspection,
  inductanceSampledFromOptions,
} from "./clampQcPageInspectionDraft";

export { clampQcFailDispositionPileLabel, type ClampQcFailDispositionPile } from "@integrator-src/config/clampqc-fail-disposition";

export function clampQcFailDispositionFromInspectionDraft(
  draft: DraftInspection,
  jobSku: string,
  hubSettings: ClampQcHubSettingsPayload | null,
  options?: ClampQcInductanceEvaluationOptions,
): ClampQcFailDispositionPile {
  if (hubSettings == null) {
    return "unrepairable";
  }
  const mechanicalFailSkipsOtherTests = clampQcMechanicalFailureSkipsOtherTests(draft.failReasons);
  const inductanceSampled = inductanceSampledFromOptions(options) && !mechanicalFailSkipsOtherTests;
  const drag = clampQcDragFromUnloadedLoadedLines(draft.unloadedLine, draft.loadedLineBeforeTester);
  const ladder = clampQcDragLadderFromSettings(jobSku, hubSettings);
  const band = clampQcDragBandForDrag(drag, ladder);
  const lineHarvestFailed =
    !mechanicalFailSkipsOtherTests &&
    clampQcLineHarvestFailsFromDragDraft(draft.lineHarvestFail, drag, jobSku, hubSettings);
  const inductanceFailed =
    inductanceSampled && clampQcInductanceReadingIsOutOfBand(draft.inductance, jobSku, hubSettings);
  const dragAutoFailed = !mechanicalFailSkipsOtherTests && band === "fail";

  return resolveClampQcFailDispositionPile({
    physicalFailReasonLabels: draft.failReasons,
    lineHarvestFailed,
    inductanceFailed,
    dragAutoFailed,
  });
}

export function clampQcFailDispositionToastForInspectionDraft(
  draft: DraftInspection,
  jobSku: string,
  hubSettings: ClampQcHubSettingsPayload | null,
  options?: ClampQcInductanceEvaluationOptions,
): string {
  const pile = clampQcFailDispositionFromInspectionDraft(draft, jobSku, hubSettings, options);
  return clampQcFailDispositionToastMessage(pile);
}
